import type { SessionData } from "../session-data.types"

type MapToSessionDataProps = {
  readonly existingSession: SessionData | null
  readonly isNewSession: boolean
  readonly now: number
}

export function mapToSessionData({
  existingSession,
  isNewSession,
  now,
}: MapToSessionDataProps): SessionData {
  if (isNewSession) {
    return {
      lastActivity: now,
      sessionCount: (existingSession?.sessionCount ?? 0) + 1,
      startTime: now,
    }
  }

  if (!existingSession) {
    return {
      lastActivity: now,
      sessionCount: 1,
      startTime: now,
    }
  }

  return {
    ...existingSession,
    lastActivity: now,
  }
}
